import React, { useState, useEffect } from 'react';
import styled from 'styled-components'
import ReactCountdownClock from "react-countdown-clock";


const RopeJumpingPage = styled.div`
    margin: 40px;
`;

const HeaderStyled = styled.div`
    font-size: 30px;
    font-weight: bold;
`;

const StartButton = styled.div`
    margin-left: 30px;
`;

const GridHeader = styled.div`
    font-size: 30px;
    font-weight: bold;
`;

const ExerciseWrapper = styled.div`
    margin-bottom: 70px;
    display: grid;
    grid-template-columns: auto auto auto;
    padding: 10px;
`;

const GridItem = styled.div`
    background-color: rgba(255, 255, 255, 0.8);
    padding: 10px;
    font-size: 30px;
`;

const ExerciseTitleStyled = styled.div`
    width: 500px;
`;

const ExerciseStatusStyled = styled.div`
`;

const DoneStyled = styled.span`
    color: green;
`;
const InProgressStyled = styled.span`
    color: blue;
    margin-left: 50px;
`;

var trainingSesion1 = [
    { exercise: "Gjør klar", duration: 15, status: "not started" },
    { exercise: "Hopp med mellomhopp", duration: 90, status: "not started" },
    { exercise: "Pause", duration: 60, status: "not started" },
    { exercise: "Annenhvert kryss", duration: 45, status: "not started" },
    { exercise: "Pause", duration: 60, status: "not started" },
    { exercise: "Doble hopp", duration: 60, status: "not started" },
    { exercise: "Pause", duration: 60, status: "not started" },
    { exercise: "Hopp med mellomhopp", duration: 90, status: "not started" },
];


const RopeJumping = () => {

    const [selectedExercise, setSelectedExercise] = useState(trainingSesion1);
    const [completions, setCompletions] = useState(0);
    const [selectedExerciseActiveTask, setSelectedExerciseActiveTask] = useState(-1);
    const [paused, setPaused] = useState(true);
    const [seconds, setSeconds] = useState(0);

    function Test() {
        StartTraining(trainingSesion1);
        setPaused(false);
    }

    function StartTraining(trainingSession) {
        // setSelectedExercise(trainingSession);
        setSelectedExerciseActiveTask(-1);
    }


    function nextExercise() {
        setCompletions(completions + 1);
        if (selectedExercise[selectedExerciseActiveTask + 1]) {
            setSeconds(selectedExercise[selectedExerciseActiveTask + 1].duration);
        }
        else {
            setPaused(true);
        }
        setSelectedExercise(prevState => {
            // Create a copy of the current state
            const updatedSessions = [...prevState];
            // Update the specific property in the specific element
            updatedSessions[selectedExerciseActiveTask] = {
                ...updatedSessions[selectedExerciseActiveTask],
                status: "done",
            };

            if (updatedSessions[selectedExerciseActiveTask + 1]) {
                updatedSessions[selectedExerciseActiveTask + 1] = {
                    ...updatedSessions[selectedExerciseActiveTask + 1],
                    status: "inProgress",
                };
            }
            return updatedSessions;
        });

        setSelectedExerciseActiveTask(selectedExerciseActiveTask + 1);


    };

    const exerciseOverview = selectedExercise.map((exercise) =>
        <>
            <GridItem>
                <ExerciseTitleStyled>{exercise.exercise}</ExerciseTitleStyled>
            </GridItem>
            <GridItem>
                <div>{exercise.duration} sekund</div>
            </GridItem>

            <GridItem>
                <ExerciseStatusStyled>
                    {exercise.status === "done" ? <DoneStyled><i className="fas fa-check"></i></DoneStyled> :
                        exercise.status === "inProgress" ?
                            <InProgressStyled><i className="fas fa-spinner fa-spin"></i> </InProgressStyled> : <></>}
                </ExerciseStatusStyled>
            </GridItem>
        </>
    );

    return (
        <RopeJumpingPage>
            <HeaderStyled>Hoppetau</HeaderStyled>

            <div>
                <ExerciseWrapper>

                    <GridItem><GridHeader>Øvelse</GridHeader></GridItem>
                    <GridItem><GridHeader>Varighet</GridHeader></GridItem>
                    <GridItem><StartButton><button className="btn btn-info" onClick={Test}>Start <i className="fa fa-play"></i></button></StartButton></GridItem>
                    {exerciseOverview}
                </ExerciseWrapper>
                <ReactCountdownClock
                    key={completions}
                    seconds={seconds}
                    paused={paused}
                    color="#006cb7"
                    alpha={0.9}
                    size={300}
                    onComplete={nextExercise} />
            </div>
        </RopeJumpingPage>
    );
};

export default RopeJumping;